import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import store from "@/store/store";

//解决点击相同菜单报NavigationDuplicated错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },
  {
    path: "/",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Register.vue")
  },
  {
    path: "/adm",
    name: "Admin",
    component: () =>
        import(/* webpackChunkName: "Admin" */ "../views/Admin.vue"),
    children: [
      {
        path: "doc-list",
        name: "DocList",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/DocList.vue")
      },
      {
        path: "edit-doc/:id/:mode",
        name: "EditDoc",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/EditDoc.vue")
      },
      {
        path: "view-doc/:id",
        name: "ViewDoc",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/ViewDoc.vue")
      },
      {
        path: "paperwork-list",
        name: "PaperworkList",
        component: () =>
          import(/* webpackChunkName: "construction" */ "../views/construction/PaperworkList.vue")
      },
      {
        path: "view-paper-work/:id",
        name: "ViewPaperWork",
        component: () =>
          import(/* webpackChunkName: "construction" */ "../views/construction/ViewPaperwork.vue")
      },
      {
        path: "edit-paper-work/:id",
        name: "EditPaperWork",
        component: () =>
          import(/* webpackChunkName: "construction" */ "../views/construction/EditPaperwork.vue")
      },
      {
        path: "progress-list",
        name: "ProgressList",
        component: () =>
          import(/* webpackChunkName: "construction" */ "../views/construction/ProgressList.vue")
      },
      {
        path: "manage-progress/:id",
        name: "ManageProgress",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/progress/ManageProgress.vue")
      },
      {
        path: "section-one/:id/:mode",
        name: "EditSectionOne",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/EditSectionOne.vue")
      },
      {
        path: "section-two/:id/:mode",
        name: "EditSectionTwo",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/EditSectionTwo.vue")
      },
      {
        path: "section-three/:id/:mode",
        name: "EditSectionThree",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/EditSectionThree.vue")
      },
      {
        path: "audit-list",
        name: "AuditList",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/AuditList.vue")
      },
      {
        path: "audit-doc/:id",
        name: "AuditDoc",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/AuditDoc.vue")
      },
      {
        path: "review/:id",
        name: "Review",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/AuditDoc.vue")
      },
      {
        path: "risk-review-list",
        name: "RiskReviewList",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/RiskReviewList.vue")
      },
      {
        path: "risk-review/:id",
        name: "RiskReview",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/RiskReview.vue")
      },
      {
        path: "risk-review-two/:id",
        name: "RiskReviewTwo",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/RiskReviewTwo.vue")
      },
      {
        path: "risk-review-three/:id",
        name: "RiskReviewThree",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/RiskReviewThree.vue")
      },
      {
        path: "user-list",
        name: "UserList",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/settings/UserList.vue")
      },
      {
        path: "edit-user/:id",
        name: "EditUser",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/settings/EditUser.vue")
      },
      {
        path: "role-list",
        name: "RoleList",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/settings/RoleList.vue")
      },
      {
        path: "set-privilege/:id",
        name: "SetPrivilege",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/settings/SetPrivilege.vue")
      },
      {
        path: "department-config",
        name: "DepartmentConfig",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/settings/DepartmentConfig.vue")
      },
      {
        path: "register-list",
        name: "UserRegisterList",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/settings/UserRegisterList.vue")
      },
      {
        path: "profile",
        name: "Profile",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/mine/Profile.vue")
      },
      {
        path: "log-list",
        name: "LogList",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/settings/LogList.vue")
      },
      {
        path: "partner-list",
        name: "PartnerList",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/partner/PartnerList.vue")
      },
      {
        path: "company-list",
        name: "CompanyList",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/company/CompanyList.vue")
      },
      {
        path: "edit-company/:id",
        name: "EditCompany",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/company/EditCompany.vue")
      },
      {
        path: "view-company/:id",
        name: "ViewCompany",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/company/ViewCompany.vue")
      },
      {
        path: "ref-doc-list",
        name: "RefDocList",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/doc/RefDocList.vue")
      },
      {
        path: "view-ref-doc/:id",
        name: "ViewRefDoc",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/doc/ViewRefDoc.vue")
      },
      {
        path: "edit-ref-doc/:id",
        name: "EditRefDoc",
        component: () =>
          import(/* webpackChunkName: "sys" */ "../views/doc/EditRefDoc.vue")
      },
      {
        path: "welcome",
        name: "Welcome",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/Welcome.vue")
      },
      {
        path: "inProgress",
        name: "InProgress",
        component: () =>
            import(/* webpackChunkName: "sys" */ "../views/InProgress.vue")
      }
    ]
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  document.documentElement.scrollTop = 0;
  NProgress.start();
  const loggedIn = localStorage.getItem("userId");
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    NProgress.done();
    next({ name: "Login" });
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
